var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publish-affiliated-panel",style:({ '--publish-notch-position': _vm.notchPosition })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }